import { render, staticRenderFns } from "./BSignUpEmailStep.vue?vue&type=template&id=4abe861e&"
import script from "./BSignUpEmailStep.vue?vue&type=script&lang=ts&"
export * from "./BSignUpEmailStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports